import axios from 'CanExConfig/axios'

export const getInitialState = async candidateId => {
  const response = await axios(`/candidate/${candidateId}/initial_state`, {
    method: 'GET',
  })

  return response.data
}
